export default __webpack_public_path__ + "static/media/logo.a687e2b4.png";